var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "employee-page" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "main-container" }, [
        !_vm.sortedProducts || _vm.sortedProducts.length == 0
          ? _c(
              "ul",
              { staticClass: "products-container no-scrollbar" },
              _vm._l(12, function(n) {
                return _c(
                  "li",
                  { key: n },
                  _vm._l(12, function(n) {
                    return _c("AddonProductSkeleton", { key: n })
                  }),
                  1
                )
              }),
              0
            )
          : _c("div", { staticClass: "products-wrapper" }, [
              _c(
                "ul",
                { staticClass: "products-container no-scrollbar best-sellers" },
                [
                  _vm._m(1),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mobile sellers" },
                    [
                      _c(
                        "Flicking",
                        {
                          ref: "featured",
                          staticClass: "flicking-bs-collection",
                          attrs: {
                            plugins: _vm.plugins1,
                            options: {
                              align: "prev",
                              circular: true,
                              preventDefaultOnDrag: true,
                              preventClickOnDrag: true,
                              panelsPerView: 2,
                              bound: true,
                              easing: function(x) {
                                return 1 - Math.pow(1 - x, 3)
                              },
                              defaultIndex: 1
                            }
                          }
                        },
                        _vm._l(_vm.bestSellers, function(product) {
                          return _c("li", { key: product.id + "bestm" }, [
                            _c(
                              "div",
                              {
                                staticClass: "product-container slider",
                                on: {
                                  click: function($event) {
                                    return _vm.selectProduct(product)
                                  }
                                }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "product-image-container" },
                                  [
                                    _c("img", {
                                      staticClass: "lazyload main-image",
                                      attrs: {
                                        width: "280",
                                        height: "280",
                                        "data-src": _vm._f("getProductImage")(
                                          product
                                        )
                                      }
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "happybox-button white border",
                                    on: {
                                      click: function($event) {
                                        return _vm.selectProduct(product)
                                      }
                                    }
                                  },
                                  [_vm._v("Shop: " + _vm._s(product.title))]
                                )
                              ]
                            )
                          ])
                        }),
                        0
                      )
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "buttons-container" }, [
                _c(
                  "button",
                  {
                    staticClass: "happybox-button white border",
                    class: _vm.totalCurrentFilters > 0 ? "selected" : "",
                    on: {
                      click: function($event) {
                        return _vm.showFilters()
                      }
                    }
                  },
                  [
                    _vm.totalCurrentFilters > 0
                      ? _c("img", {
                          staticClass: "purple",
                          attrs: {
                            src:
                              "https://cdn.shopify.com/s/files/1/1363/8433/files/filter_purple.svg?v=1723141690"
                          }
                        })
                      : _c("img", {
                          staticClass: "normal",
                          attrs: {
                            src:
                              "https://cdn.shopify.com/s/files/1/1363/8433/files/filters.png?v=1722266559"
                          }
                        }),
                    _vm._v(" "),
                    _c("span", { staticClass: "desktop" }, [_vm._v("Filters")]),
                    _vm._v(" "),
                    _c("span", { staticClass: "mobile" }, [
                      _vm._v("Filter by Occasion")
                    ]),
                    _vm._v(" "),
                    _vm.totalCurrentFilters > 0
                      ? _c("span", [
                          _vm._v("(" + _vm._s(_vm.totalCurrentFilters) + ")")
                        ])
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "happybox-button white border",
                    on: {
                      click: function($event) {
                        return _vm.showSort()
                      }
                    }
                  },
                  [
                    _c("img", {
                      attrs: {
                        src:
                          "https://cdn.shopify.com/s/files/1/1363/8433/files/Group_4412.png?v=1722267051"
                      }
                    }),
                    _vm._v("Sort")
                  ]
                )
              ]),
              _vm._v(" "),
              _vm.showReco
                ? _c(
                    "ul",
                    {
                      staticClass: "products-container no-scrollbar",
                      attrs: { id: "recoProducts" }
                    },
                    [
                      _vm._l(_vm.occasionProducts, function(set) {
                        return [
                          _c("p", { staticClass: "other-gifts" }, [
                            _vm._v(_vm._s(set.occasion) + " Gifts")
                          ]),
                          _vm._v(" "),
                          _vm._l(set.products, function(product) {
                            return _c(
                              "li",
                              { key: product.id + set.occasion },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "product-container",
                                    on: {
                                      click: function($event) {
                                        return _vm.selectProduct(product)
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "product-image-container"
                                      },
                                      [
                                        _c("img", {
                                          staticClass: "lazyload main-image",
                                          attrs: {
                                            width: "280",
                                            height: "280",
                                            "data-src": _vm._f(
                                              "getProductImage"
                                            )(product)
                                          }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "happybox-button white border",
                                        on: {
                                          click: function($event) {
                                            return _vm.selectProduct(product)
                                          }
                                        }
                                      },
                                      [_vm._v("Add to cart ")]
                                    ),
                                    _vm._v(" "),
                                    _c("p", { staticClass: "title" }, [
                                      _vm._v(_vm._s(product.title))
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "product-price-container"
                                      },
                                      [
                                        product.variants.find(function(x) {
                                          return (
                                            x.price != "" && x.price != "0.00"
                                          )
                                        }).compare_at_price
                                          ? _c(
                                              "span",
                                              { staticClass: "discount-price" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("moneySaleFormat")(
                                                      product.variants.find(
                                                        function(x) {
                                                          return (
                                                            x.price != "" &&
                                                            x.price != "0.00"
                                                          )
                                                        }
                                                      ).compare_at_price
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "price" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("moneyFormat")(product)
                                            )
                                          )
                                        ])
                                      ]
                                    )
                                  ]
                                )
                              ]
                            )
                          })
                        ]
                      })
                    ],
                    2
                  )
                : _c(
                    "ul",
                    {
                      staticClass: "products-container no-scrollbar",
                      attrs: { id: "allProducts" }
                    },
                    [
                      _c("p", { staticClass: "other-gifts" }, [
                        _vm._v(_vm._s(_vm.breadcrumbText))
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.sortedProducts, function(product) {
                        return _c("li", { key: product.id }, [
                          _c(
                            "div",
                            {
                              staticClass: "product-container",
                              on: {
                                click: function($event) {
                                  return _vm.selectProduct(product)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "product-image-container" },
                                [
                                  _c("img", {
                                    staticClass: "lazyload main-image",
                                    attrs: {
                                      width: "280",
                                      height: "280",
                                      "data-src": _vm._f("getProductImage")(
                                        product
                                      )
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "happybox-button white border",
                                  on: {
                                    click: function($event) {
                                      return _vm.selectProduct(product)
                                    }
                                  }
                                },
                                [_vm._v("Add to cart ")]
                              ),
                              _vm._v(" "),
                              _c("p", { staticClass: "title" }, [
                                _vm._v(_vm._s(product.title))
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "product-price-container" },
                                [
                                  product.variants.find(function(x) {
                                    return x.price != "" && x.price != "0.00"
                                  }).compare_at_price
                                    ? _c(
                                        "span",
                                        { staticClass: "discount-price" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("moneySaleFormat")(
                                                product.variants.find(function(
                                                  x
                                                ) {
                                                  return (
                                                    x.price != "" &&
                                                    x.price != "0.00"
                                                  )
                                                }).compare_at_price
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "price" }, [
                                    _vm._v(
                                      _vm._s(_vm._f("moneyFormat")(product))
                                    )
                                  ])
                                ]
                              )
                            ]
                          )
                        ])
                      }),
                      _vm._v(" "),
                      _vm.nonFilteredProducts.length > 0
                        ? _c("p", { staticClass: "other-gifts" }, [
                            _vm._v("All Other Gifts")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.nonFilteredProducts, function(product) {
                        return _c("li", { key: product.id }, [
                          _c(
                            "div",
                            {
                              staticClass: "product-container",
                              on: {
                                click: function($event) {
                                  return _vm.selectProduct(product)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "product-image-container" },
                                [
                                  _c("img", {
                                    staticClass: "lazyload main-image",
                                    attrs: {
                                      width: "280",
                                      height: "280",
                                      "data-src": _vm._f("getProductImage")(
                                        product
                                      )
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "happybox-button white border",
                                  on: {
                                    click: function($event) {
                                      return _vm.selectProduct(product)
                                    }
                                  }
                                },
                                [_vm._v("Add to cart ")]
                              ),
                              _vm._v(" "),
                              _c("p", { staticClass: "title" }, [
                                _vm._v(_vm._s(product.title))
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "product-price-container" },
                                [
                                  product.variants.find(function(x) {
                                    return x.price != "" && x.price != "0.00"
                                  }).compare_at_price
                                    ? _c(
                                        "span",
                                        { staticClass: "discount-price" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("moneySaleFormat")(
                                                product.variants.find(function(
                                                  x
                                                ) {
                                                  return (
                                                    x.price != "" &&
                                                    x.price != "0.00"
                                                  )
                                                }).compare_at_price
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "price" }, [
                                    _vm._v(
                                      _vm._s(_vm._f("moneyFormat")(product))
                                    )
                                  ])
                                ]
                              )
                            ]
                          )
                        ])
                      })
                    ],
                    2
                  )
            ])
      ]),
      _vm._v(" "),
      _vm.filterIsShown
        ? _c("FiltersMobile", {
            attrs: {
              filteredPreAddons: _vm.filteredPreProducts,
              filteredAddons: _vm.sortedProducts
            },
            on: {
              closefilter: function($event) {
                return _vm.showFilters()
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.sortIsShown
        ? _c("SortMobile", {
            on: {
              closefilter: function($event) {
                return _vm.showSort()
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header-container" }, [
      _c("picture", { staticClass: "header-picture" }, [
        _c("source", {
          attrs: {
            media: "(max-width: 767px)",
            srcset:
              "https://cdn.shopify.com/s/files/1/1363/8433/files/Curated_Header_Mobile.png?v=1744720211"
          }
        }),
        _vm._v(" "),
        _c("img", {
          staticClass: "main-image",
          attrs: {
            src:
              "https://cdn.shopify.com/s/files/1/1363/8433/files/Curated_Header.png?v=1744720210"
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "title-container" }, [
        _c("p", { staticClass: "title" }, [_vm._v("Shop Gift Sets")]),
        _vm._v(" "),
        _c("p", { staticClass: "subtitle desktop" }, [
          _vm._v("Unique gifts, expertly curated")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "instructions" }, [
          _c("div", { staticClass: "first" }, [
            _c("img", {
              attrs: {
                src:
                  "https://cdn.shopify.com/s/files/1/1363/8433/files/address.svg?v=1721239631"
              }
            }),
            _vm._v(" "),
            _c("p", [_vm._v("Ship via email")])
          ]),
          _vm._v(" "),
          _c("div", [
            _c("img", {
              attrs: {
                src:
                  "https://cdn.shopify.com/s/files/1/1363/8433/files/ship_f963b592-b5a1-4844-bb0b-78bd22e5671a.svg?v=1725918596"
              }
            }),
            _vm._v(" "),
            _c("p", [_vm._v("Bulk shipping")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "last" }, [
            _c("img", {
              attrs: {
                src:
                  "https://cdn.shopify.com/s/files/1/1363/8433/files/note.svg?v=1721239631"
              }
            }),
            _vm._v(" "),
            _c("p", [_vm._v("Handwritten cards")])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "main-title" }, [
      _vm._v("Shop "),
      _c("span", [_vm._v("Best Selling")]),
      _vm._v(" Curated Gifts")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }